import React, { useState, useEffect, useRef } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { motion } from 'framer-motion';
import 'keen-slider/keen-slider.min.css';

const categories = ["Gender", "Generations", "Abilities", "Culture", "LGBTQ+"];

const focusData = [
  {
    id: 1,
    category: "Gender",
    title: "Focused Hiring",
    number: "01",
    description: "We are leading the way by leveraging technology that our customers to monitor, measure, improve, and achieve the desired business outcomes sustainably."
  },
  {
    id: 2,
    category: "Gender",
    title: "Inclusive Development",
    number: "02",
    description: "We are leading the way by leveraging technology that our customers to monitor, measure, improve, and achieve the desired business outcomes sustainably."
  },
  {
    id: 3,
    category: "Gender",
    title: "Celebrating Women",
    number: "03",
    description: "We are leading the way by leveraging technology that our customers to monitor, measure, improve, and achieve the desired business outcomes sustainably."
  },
  {
    id: 4,
    category: "Gender",
    title: "Equal Opportunities",
    number: "04",
    description: "We are leading the way by leveraging technology that our customers to monitor, measure, improve, and achieve the desired business outcomes sustainably."
  }
];

const FocusAreasSection = () => {
  const [activeTab, setActiveTab] = useState("Gender");
  const timerRef = useRef(null);

  const filteredData = focusData.filter(item => item.category === activeTab);

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    slides: {
      perView: 1,
      spacing: 16,
    },
    breakpoints: {
      '(min-width: 640px)': {
        slides: { perView: 2, spacing: 20 },
      },
      '(min-width: 1024px)': {
        slides: { perView: 3, spacing: 24 },
      },
    },
    created(s) {
      s.container.addEventListener("mouseover", () => clearTimeout(timerRef.current));
      s.container.addEventListener("mouseout", () => startAutoplay(s));
      startAutoplay(s);
    },
    destroyed() {
      clearTimeout(timerRef.current);
    }
  });

  useEffect(() => {
    if (instanceRef.current) {
      instanceRef.current.update();
    }
  }, [filteredData, instanceRef]);

  const startAutoplay = (sliderInstance) => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      sliderInstance.next();
      startAutoplay(sliderInstance);
    }, 4000);
  };

  return (
    <section className="w-full bg-[#FFFFFF] py-16 lg:py-24 overflow-hidden select-none text-left relative z-50">
      <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

        <div className="w-full flex flex-col md:flex-row md:items-center justify-between gap-6 mb-2 lg:mb-[50px] pb-4">
          <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora shrink-0">
            Focus Areas
          </h2>

          <div className="flex items-center gap-4 sm:gap-6 overflow-x-auto no-scrollbar scroll-smooth py-1">
            {categories.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`text-[14px] sm:text-[16px] font-[600] whitespace-nowrap pb-2 transition-all duration-300 relative rounded-none ${activeTab === tab ? "text-[#EA580C]" : "text-[#49577A] hover:text-[#01386A]"
                  }`}
              >
                {tab}
                {activeTab === tab && (
                  <motion.div
                    layoutId="activeTabUnderline"
                    className="absolute bottom-0 left-0 right-0 h-[3px] bg-[#EA580C]"
                  />
                )}
              </button>
            ))}
          </div>
        </div>

        <div className="relative w-full">
          <div ref={sliderRef} className="keen-slider w-full !overflow-visible sm:!overflow-hidden">
            {filteredData.map((slide) => (
              <div key={slide.id} className="keen-slider__slide">
                <div className="group relative bg-white border border-[#01386A45] p-6 sm:p-8 flex flex-col justify-between h-[250px] sm:h-[280px] md:h-[320px] transition-shadow duration-300 hover:shadow-lg cursor-grab active:cursor-grabbing overflow-hidden rounded-none">

                  <div className="flex justify-between items-start gap-4 w-full">
                    <h3 className="text-[16px] lg:text-[20px] font-[600] text-[#01386A] max-w-[75%] font-sora">
                      {slide.title}
                    </h3>
                    <span className="text-[16px] md:text-[20px] font-[600] text-[#01386A] shrink-0 font-sora">
                      {slide.number}
                    </span>
                  </div>

                  <div className="mt-4 w-full">
                    <p className="text-[#49577A] text-[14px] md:text-[16px] font-graphik leading-relaxed font-[500] line-clamp-5 sm:line-clamp-none">
                      {slide.description}
                    </p>
                  </div>

                  <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                  <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] transition-all duration-500 ease-out group-hover:w-full z-10"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-3 mt-8">
          <button
            onClick={() => instanceRef.current?.prev()}
            className="w-10 h-10 rounded-full border border-[#EA580C] flex items-center justify-center text-[#EA580C] bg-white hover:bg-[#EA580C] hover:text-white transition-all duration-300 active:scale-95"
          >
            <span className="font-mono text-[18px] font-bold">&larr;</span>
          </button>
          <button
            onClick={() => instanceRef.current?.next()}
            className="w-10 h-10 rounded-full border border-[#EA580C] flex items-center justify-center text-[#EA580C] bg-white hover:bg-[#EA580C] hover:text-white transition-all duration-300 active:scale-95"
          >
            <span className="font-mono text-[18px] font-bold">&rarr;</span>
          </button>
        </div>

      </div>
    </section>
  );
};

export default FocusAreasSection;